import axios from "./base"

export default {
  config() {
    return axios.get("/config")
  },
  googleLogin(data) {
    return axios.post("/login/google", data)
  },
  appleLogin(data) {
    return axios.post("/login/apple", data)
  },
  getCommunications(data) {
    return axios.get("/communications", { params: data })
  },
  getCommunication(id, data) {
    return axios.get(`/communications/${id}`, { params: data })
  },
  getEvents(data) {
    return axios.get("/events", { params: data })
  },
  createEvent(data) {
    return axios.post("/events/", data)
  },
  updateEvent(id, data) {
    return axios.patch(`/events/${id}`, data)
  },
  destroyEvent(id) {
    return axios.delete(`/events/${id}`)
  },
  getEventRegistrations(data) {
    return axios.get("/event_registrations", { params: data })
  },
  getEventAvailability(eventId, data) {
    return axios.get(`/events/${eventId}/availability`, { params: data })
  },
  getProducts(data) {
    return axios.get("/store/products", { params: data })
  },
  searchProductDictionary(data) {
    return axios.get("/store/product-dictionary", { params: data })
  },
  getFavoriteProducts(data = {}) {
    return axios.get("/store/favorite-products", { params: data })
  },
  addFavoriteProduct(data) {
    return axios.post("/store/favorite-products", data)
  },
  removeFavoriteProduct(productId) {
    return axios.delete(`/store/favorite-products/${productId}`)
  },
  getPromotionTags() {
    return axios.get("/store/promotion_tags")
  },
  getPromotionCards(data) {
    return axios.get("/store/promotions", { params: data })
  },
  getPromotion(id) {
    return axios.get(`/store/promotions/${id}`)
  },
  getProductCollection(id) {
    return axios.get(`/product-collections/${id}`)
  },
  createProduct(data) {
    return axios.post("/store/products", data)
  },
  updateProduct(id, data) {
    return axios.patch(`/store/products/${id}`, data)
  },
  destroyProduct(id) {
    return axios.delete(`/store/products/${id}`)
  },
  getUsers(data) {
    return axios.get("/user_profiles", { params: data })
  },
  subscribeEvent(data) {
    return axios.post("/event_registrations", data)
  },
  getPromotions(data) {
    return axios.get("/promotions", { params: data })
  },
  updateUserProfile(data) {
    return axios.patch("/profile", data)
  },
  updateCompanyProfile(data) {
    return axios.patch("/company_profiles", data)
  },
  createFaq(data) {
    return axios.post("/faqs/", data)
  },
  updateFaq(id, data) {
    return axios.patch(`/faqs/${id}`, data)
  },
  destroyFaq(id) {
    return axios.delete(`/faqs/${id}`)
  },
  createPrescription(data) {
    return axios.post("/prescriptions/", data)
  },
  bulkCreatePrescriptions(data) {
    return axios.post("/prescriptions/bulk", data)
  },
  updatePrescription(id, data) {
    return axios.patch(`/prescriptions/${id}`, data)
  },
  updatePrescriptionSelection(id, data) {
    return axios.patch(`/prescriptions/${id}/selection`, data)
  },
  destroyPrescription(id) {
    return axios.delete(`/prescriptions/${id}`)
  },
  createSpecialRequest(data) {
    return axios.post("/special_requests/", data)
  },
  createUploadSignature(data) {
    return axios.post("/upload-presigns", data)
  },
  updateSpecialRequest(id, data) {
    return axios.patch(`/special_requests/${id}`, data)
  },
  updateSpecialRequestSelection(id, data) {
    return axios.patch(`/special_requests/${id}/selection`, data)
  },
  destroySpecialRequest(id) {
    return axios.delete(`/special_requests/${id}`)
  },
  addToCart(data) {
    return axios.post("/store/carts", data)
  },
  submitPrescriptionCart(data) {
    return axios.post("/store/carts/submission", data)
  },
  updateQuantity(line_item_id, data) {
    return axios.patch(`/store/items/${line_item_id}`, data)
  },
  removeFromCart(data) {
    return axios.delete("/store/carts", { data: data })
  },
  getSavedItems(data = {}) {
    return axios.get("/store/saved-items", { params: data })
  },
  saveCartItem(data) {
    return axios.post("/store/saved-items", data)
  },
  removeSavedItem(variantId) {
    return axios.delete(`/store/saved-items/${variantId}`)
  },
  moveSavedItemToCart(variantId) {
    return axios.post(`/store/saved-items/${variantId}/move-to-cart`)
  },
  applyCartCoupon(data) {
    return axios.post("/store/coupon", data)
  },
  removeCoupon(data) {
    return axios.delete("/store/coupon", { data: data })
  },
  getAddresses() {
    return axios.get("/store/addresses")
  },
  getZipcode(zipcode) {
    return axios.get("/store/zipcode", { params: { zipcode } })
  },
  createAddress(data) {
    return axios.post("/store/addresses", data)
  },
  updateAddress(id, data) {
    return axios.patch(`/store/addresses/${id}`, data)
  },
  deleteAddress(id) {
    return axios.delete(`/store/addresses/${id}`)
  },
  getRates() {
    return axios.get("/store/rates", {
      params: {
        include: [
          "shipping_rates",
          "pickup_location",
          "shipping_rates.shipping_method",
          "shipping_rates.shipping_method.locations",
        ],
      },
    })
  },
  updateCheckout(data) {
    return axios.patch("/store/checkout", data)
  },
  createComment(URL, data) {
    return axios.post(URL, data)
  },
  createOrderEvent(data) {
    return axios.post("/store/order-events", data)
  },
  updateRecommended(data) {
    return axios.post("/store/recommended-products", data)
  },
  updateHighlighted(data) {
    return axios.post("/store/highlighted-products", data)
  },
  updateUnavailable(data) {
    return axios.post("/store/unavailable-products", data)
  },
  sendPush(data) {
    return axios.post("/notifications", data)
  },
  deleteAccount() {
    return axios.delete("/account")
  },
  checkPaymentStatus(cartId, id) {
    return axios.get(`/store/payment-status/${id}?cart_id=${cartId}`)
  },
  realtimeToken() {
    return axios.get("/realtime-token")
  },
  fetchNotifications() {
    return axios.get("/notifications")
  },
  markNotificationRead(id) {
    return axios.post(`/notifications/${id}/mark_read`)
  },
  markAllNotificationsRead() {
    return axios.post("/notifications/mark-all-read")
  },
  getMessages(data) {
    return axios.get("/messages", { params: data })
  },
  getMessagesUnreadCount() {
    return axios.get("/messages/unread_count")
  },
  markMessageRead(id) {
    return axios.post(`/messages/${id}/mark_read`)
  },
  markItemMessagesRead(data) {
    return axios.post("/messages/mark_read_for_item", data)
  },
  updateSettings(data) {
    return axios.patch("/settings", data)
  },
  applyLoyaltyPoints(data = {}) {
    return axios.post("/store/apply-points", data)
  },
  fetchPermissions() {
    return axios.get("/features")
  },
  createMeasurement(data) {
    return axios.post("/measurements", data)
  },
  destroyMeasurement(id) {
    return axios.delete(`/measurements/${id}`)
  },
  getMeasurements(data = {}) {
    return axios.get("/measurements", { params: data })
  },
  getDosages() {
    return axios.get("/dosages")
  },
  createDosage(payload) {
    return axios.post("/dosages", payload)
  },
  pauseDosage(id) {
    return axios.post(`/dosages/${id}/pause`)
  },
  activateDosage(id) {
    return axios.post(`/dosages/${id}/activate`)
  },
  updateDosage(id, payload) {
    return axios.patch(`/dosages/${id}`, payload)
  },
  deleteDosage(id) {
    return axios.delete(`/dosages/${id}`)
  },
  createLoyaltyWallet(data) {
    return axios.post("/loyalty-wallet", data)
  },
  getLoyaltyStatistics() {
    return axios.get("/loyalty-wallet/statistics")
  },
  updateLocale(data) {
    return axios.patch("/language", data)
  },
  getMeasurementUsers(data = {}) {
    return axios.get("/measurement-users", { params: data })
  },
  getMeasurementUser(id) {
    return axios.get(`/measurement-users/${id}`)
  },
  createMeasurementUser(data) {
    return axios.post("/measurement-users", data)
  },
  updateMeasurementUser(id, data) {
    return axios.patch(`/measurement-users/${id}`, data)
  },
  destroyMeasurementUser(id) {
    return axios.delete(`/measurement-users/${id}`)
  },
  getMeasurementCharts(data = {}) {
    return axios.get("/measurement-charts", { params: data })
  },
  fetchPolicies() {
    return axios.get("/company-policies")
  },
  fetchUserConsents(data) {
    return axios.get("/user-consents", { params: data })
  },
  createUserConsent(data) {
    return axios.post("/user-consents", data)
  },
  destroyUserConsent(id) {
    return axios.delete(`/user-consents/${id}`)
  },
}
